import React from 'react';
import { Wrapper, Form, Button } from 'components';
import withDefaultProps from 'helpers/withDefaultProps';
import PropTypes from 'prop-types';
import * as Ui from './ModalForm.styles';

const ModalForm = ({
  renderDefaultButtons = true,
  cancelLabel = 'Cancel',
  submitLabel = 'Submit',
  extraButtons,
  header,
  pristine = false,
  isLoading = false,
  ignoreClickedState = false,
  children,
  isClosePopupOn = true,
  style,
  bodyStyle,
  bodyContentStyle,
  ...restProps
}) => (
  <Ui.Form renderDefaultButtons={false} style={style} {...restProps}>
    {(formikProps) => (
      <>
        {header && (
          <Ui.Header>{typeof header === 'function' ? header(formikProps) : header}</Ui.Header>
        )}

        <Ui.Body style={bodyStyle}>
          <Ui.BodyContent style={bodyContentStyle}>
            {typeof children === 'function' ? children(formikProps) : children}
          </Ui.BodyContent>
        </Ui.Body>

        <Ui.Footer>
          {({ closePopup }) => (
            <Wrapper d-flex justify-content-end>
              {typeof extraButtons === 'function'
                ? extraButtons({ ...formikProps, closePopup })
                : extraButtons}

              {renderDefaultButtons && (
                <>
                  <Button onClick={closePopup} variant="white" className="mr-3">
                    {cancelLabel}
                  </Button>

                  <Form.Submit
                    onClick={isClosePopupOn ? closePopup : undefined}
                    pristine={pristine}
                    isLoading={isLoading}
                    ignoreClickedState={ignoreClickedState}
                  >
                    {submitLabel}
                  </Form.Submit>
                </>
              )}
            </Wrapper>
          )}
        </Ui.Footer>
      </>
    )}
  </Ui.Form>
);

/*       Proptypes        */

ModalForm.propTypes = {
  renderDefaultButtons: PropTypes.bool,
  cancelLabel: PropTypes.string,
  submitLabel: PropTypes.string,
  extraButtons: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  header: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  bodyStyle: PropTypes.object,
  bodyContentStyle: PropTypes.object,
  pristine: PropTypes.bool,
  isLoading: PropTypes.bool,
  ignoreClickedState: PropTypes.bool,
  isClosePopupOn: PropTypes.bool,
  ...withDefaultProps(),
};

export default ModalForm;
